import React from "react";

/**
 * Simple per-route SEO head updater for a CRA SPA.
 * Updates <title>, <meta name="description">, <link rel="canonical">,
 * og:title/description/url and twitter:title/description on mount and
 * restores previous values on unmount.
 */
export default function usePageMeta({ title, description, path }) {
  React.useEffect(() => {
    if (typeof document === "undefined") return;

    const prevTitle = document.title;
    const prevDesc = document.querySelector('meta[name="description"]')?.getAttribute("content");
    const prevCanonical = document.querySelector('link[rel="canonical"]')?.getAttribute("href");
    const prevOgTitle = document.querySelector('meta[property="og:title"]')?.getAttribute("content");
    const prevOgDesc = document.querySelector('meta[property="og:description"]')?.getAttribute("content");
    const prevOgUrl = document.querySelector('meta[property="og:url"]')?.getAttribute("content");
    const prevTwTitle = document.querySelector('meta[name="twitter:title"]')?.getAttribute("content");
    const prevTwDesc = document.querySelector('meta[name="twitter:description"]')?.getAttribute("content");

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el && value != null) el.setAttribute(attr, value);
    };

    const fullUrl = path ? `https://getcvaipro.com${path}` : undefined;

    if (title) document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", fullUrl);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", fullUrl);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);

    return () => {
      if (prevTitle) document.title = prevTitle;
      setMeta('meta[name="description"]', "content", prevDesc);
      setMeta('link[rel="canonical"]', "href", prevCanonical);
      setMeta('meta[property="og:title"]', "content", prevOgTitle);
      setMeta('meta[property="og:description"]', "content", prevOgDesc);
      setMeta('meta[property="og:url"]', "content", prevOgUrl);
      setMeta('meta[name="twitter:title"]', "content", prevTwTitle);
      setMeta('meta[name="twitter:description"]', "content", prevTwDesc);
    };
  }, [title, description, path]);
}
